import React from 'react';
import styled from 'styled-components'
import PropTypes from 'prop-types';
import Markdown from '../markdown';
import { stringSubstitution } from './util';
import CommonPropTypes from '../common-prop-types';

import { registerWidget } from './sections';

/**
 * @param {Object} props
 * @param {String} props.title
 * @param {String} props.subTitle
 * @param {String} props.headerClass
 * @param {Object} props.stringSubstitutions
 * @param {String} props.caption
 * @param {String} props.videoUrl
 * @param {String} props.className
 */
const VideoSection = ({
  title,
  subTitle,
  headerClass,
  stringSubstitutions,
  caption,
  videoUrl,
  className,
}) => {
  const titleString = stringSubstitution(title, stringSubstitutions);
  const titleElement = title && (
    <h2 className={headerClass}>
      {titleString}
    </h2>
  );
  const subTitleElement = subTitle && <h3 className='subTitle'>{stringSubstitution(subTitle, stringSubstitutions)}</h3>;
  const captionElement = caption && <Markdown className='caption' source={stringSubstitution(caption, stringSubstitutions)} />;
  const titleSection = (titleElement || subTitleElement) && (
    <div className='titleSection'>
      {titleElement}
      {subTitleElement}
    </div>
  );
  const youtubeURL = videoUrl.replace('watch?v=', 'embed/');
  return (
    <div className={`VideoSection ${className}`}>
      { titleSection }
      <iframe title={titleString} width='800' height='400' src={youtubeURL} />
      { captionElement }
    </div>
  );
};

export const textSectionPropTypes = {
  title: PropTypes.string,
  subTitle: PropTypes.string,
  caption: PropTypes.string,
  videoUrl: PropTypes.string.isRequired,
  className: PropTypes.string,
  headerClass: PropTypes.string,
  stringSubstitutions: CommonPropTypes.stringSubstitutions,
};

VideoSection.propTypes = textSectionPropTypes;

VideoSection.defaultProps = {
  title: null,
  subTitle: null,
  caption: null,
  className: '',
  headerClass: 'h2',
  stringSubstitutions: {},
};

const StyledVideoSection = styled(VideoSection)`
padding-bottom: 4rem;
iframe {
  max-width: 100%;
  padding-top: 1rem;
}

h3 {
  font-size: 1.5rem;
  margin-bottom: 1rem;
  color: #c8cbd0;
}
h2 { margin-bottom: 0.5rem; }

.titleSection {
  margin-bottom: 1rem;
}
`

registerWidget('videoSection', StyledVideoSection);

export default StyledVideoSection;
